<template>
  <header id="header2">
    <!-- TOP SECTION: Background with Person + Title on left -->
    <div class="top-section">
      <b-container fluid class="px-0">
        <div class="top-content">
          <div class="title-section">
            <h2 class="main-title">人材確保の課題は</h2>
            <h1 class="main-title-brand">
              <span class="highlight">ASUKA</span
              ><span class="title-text">が解決！</span>
            </h1>
            <!-- Contact Section -->
            <div class="contact-section">
              <div class="contact-inner">
                <div class="contact-phone">
                  <font-awesome-icon
                    icon="fa-solid fa-phone"
                    class="phone-icon"
                  />
                  <span class="phone-number">052-977-9445</span>
                  <span class="business-hours">受付時間 平日9:00〜18:00</span>
                </div>
                <div class="contact-btn-wrapper">
                  <b-button class="consultation-button" @click="callPhone">
                    無料相談はこちら
                    <font-awesome-icon
                      icon="fa-solid fa-chevron-right"
                      class="ml-1"
                    />
                  </b-button>
                </div>
              </div>
            </div>

            <div class="cert-mini-section">
              <div class="cert-mini-card">
                <p class="cert-mini-head">株式会社 ASUKA</p>
                <p class="cert-mini-title">登録支援機関</p>
                <p class="cert-mini-no">許可番号 19登-000755</p>
              </div>
              <div class="cert-mini-card">
                <p class="cert-mini-head">株式会社 ASUKA</p>
                <p class="cert-mini-title">有料職業紹介事業</p>
                <p class="cert-mini-no">許可番号 23-ユ-302053</p>
              </div>
              <div class="cert-mini-card">
                <p class="cert-mini-head">株式会社 ASUKA</p>
                <p class="cert-mini-title">労働者派遣事業</p>
                <p class="cert-mini-no">許可番号 派 23-303854</p>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </div>

    <!-- BOTTOM SECTION: Problems + CTA + Contact -->
    <div class="bottom-section">
      <b-container fluid class="px-0">
        <!-- 5 Problems Icons Section -->
        <div class="problems-section">
          <div class="problems-label">こんなお悩みありませんか？</div>
          <div
            class="problems-track-wrapper"
            ref="trackWrapper"
            @mouseenter="pauseAnim"
            @mouseleave="resumeAnim"
          >
            <div class="problems-container" ref="track">
            <div class="problem-item">
              <div class="icon-wrapper">
                <img
                  :src="require('@/assets/home/icon-worker-shortage.svg')"
                  alt="人手不足"
                  class="problem-icon-img"
                />
              </div>
              <p class="problem-text">人手不足で<br />生産が追いつかない</p>
            </div>
            <div class="problem-item">
              <div class="icon-wrapper">
                <img
                  :src="require('@/assets/home/icon-employee-turnover.svg')"
                  alt="離職"
                  class="problem-icon-img"
                />
              </div>
              <p class="problem-text">採用しても<br />すぐ辞めてしまう</p>
            </div>
            <div class="problem-item">
              <div class="icon-wrapper">
                <img
                  :src="require('@/assets/home/icon-high-cost.svg')"
                  alt="コスト"
                  class="problem-icon-img"
                />
              </div>
              <p class="problem-text">採用・教育<br />コストが高い</p>
            </div>
            <div class="problem-item">
              <div class="icon-wrapper">
                <img
                  :src="require('@/assets/home/icon-foreign-procedure.svg')"
                  alt="手続き"
                  class="problem-icon-img"
                />
              </div>
              <p class="problem-text">外国人採用は<br />手続きが不安</p>
            </div>
            <div class="problem-item">
              <div class="icon-wrapper">
                <img
                  :src="require('@/assets/home/icon-seasonal-hiring.svg')"
                  alt="繁忙期"
                  class="problem-icon-img"
                />
              </div>
              <p class="problem-text">繁忙期だけ<br />人を増やしたい</p>
            </div>
            </div><!-- end problems-container -->
          </div><!-- end problems-track-wrapper -->
        </div>

        <!-- CTA Button -->
        <div class="cta-section text-center">
          <b-button class="cta-button" @click="$router.push({ name: 'contact' })">
            人材に関するお悩みをご相談ください
            <font-awesome-icon
              icon="fa-solid fa-chevron-right"
              class="cta-arrow"
            />
          </b-button>
        </div>
        <!-- Contact Section -->
        <div class="contact-section-mobile">
          <div class="contact-inner">
            <div class="contact-phone">
              <font-awesome-icon icon="fa-solid fa-phone" class="phone-icon" />
              <span class="phone-number">052-977-9445</span>
              <span class="business-hours">受付時間 平9:00〜18:00</span>
            </div>
            <div class="contact-btn-wrapper">
              <b-button class="consultation-button" @click="callPhone">
                無料相談はこちら
                <font-awesome-icon
                  icon="fa-solid fa-chevron-right"
                  class="ml-1"
                />
              </b-button>
            </div>
          </div>
        </div>
      </b-container>
    </div>
  </header>
</template>

<script>
import gsap from "gsap";

export default {
  name: "Header2",
  data() {
    return {
      tween: null,
      tickerCb: null,
    };
  },
  mounted() {
    if (window.innerWidth >= 768) {
      this.$nextTick(() => this.initAnim());
    }
  },
  beforeDestroy() {
    if (this.tween) this.tween.kill();
    if (this.tickerCb) gsap.ticker.remove(this.tickerCb);
  },
  methods: {
    callPhone() {
      window.location.href = "tel:0529779445";
    },

    initAnim() {
      const track = this.$refs.track;
      const wrapper = this.$refs.trackWrapper;
      if (!track || !wrapper) return;

      // Clone all items for seamless loop
      const origItems = Array.from(track.children);
      origItems.forEach((item) => {
        track.appendChild(item.cloneNode(true));
      });

      requestAnimationFrame(() => {
        const setWidth = origItems.reduce((s, el) => s + el.offsetWidth, 0);
        if (!setWidth) return;

        // Continuous smooth scroll
        this.tween = gsap.to(track, {
          x: -setWidth,
          duration: 12,
          ease: "none",
          repeat: -1,
        });

        // Scale items based on distance from wrapper center
        this.tickerCb = () => {
          const wRect = wrapper.getBoundingClientRect();
          const centerX = wRect.left + wRect.width / 2;
          const zone = wRect.width * 0.18;
          const items = track.querySelectorAll(".problem-item");
          items.forEach((item) => {
            const r = item.getBoundingClientRect();
            const itemCx = r.left + r.width / 2;
            const dist = Math.abs(itemCx - centerX);
            const t = Math.max(0, 1 - dist / zone);
            const scale = 1 + 0.3 * t; // 1.0 → 1.3
            gsap.set(item, { scale, transformOrigin: "center center" });
          });
        };
        gsap.ticker.add(this.tickerCb);
      });
    },

    pauseAnim() {
      if (this.tween) this.tween.pause();
    },

    resumeAnim() {
      if (this.tween) this.tween.resume();
    },
  },
};
</script>

<style scoped>
#header2 {
  width: 100%;
  height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* =====================
   TOP SECTION (Background with Person + Title)
   ===================== */
.top-section {
  width: 100%;
  flex: 0 0 60%;
  background-image: url("~@/assets/home/asuka_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.top-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.85) 0%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
}

.top-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  position: relative;
  z-index: 1;
}

.title-section {
  text-align: left;
  max-width: 550px;
}

.main-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e3a5f;
  line-height: 1.5;
  margin-bottom: 8px;
  font-family: "Hiragino Kaku Gothic ProN", "Yu Gothic", "Meiryo", sans-serif;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.main-title-brand {
  font-size: 42px;
  font-weight: 700;
  color: #1e3a5f;
  line-height: 1.3;
  margin-bottom: 12px;
  font-family: "Hiragino Kaku Gothic ProN", "Yu Gothic", "Meiryo", sans-serif;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.main-title-brand .highlight {
  color: #d4a012;
  font-size: 56px;
  font-weight: 800;
  font-style: italic;
  letter-spacing: 2px;
  text-shadow: 0 2px 4px rgba(212, 160, 18, 0.3);
}

.main-title-brand .title-text {
  color: #1e3a5f;
}

.sub-title {
  font-size: 16px;
  color: #4a5a6a;
  margin-top: 10px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.cert-mini-section {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.cert-mini-card {
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(20, 56, 112, 0.2);
  border-radius: 8px;
  padding: 7px 8px;
  text-align: center;
  position: relative;
  box-shadow: 0 1px 6px rgba(20, 56, 112, 0.08);
}

.cert-mini-card::before {
  content: "";
  position: absolute;
  inset: 3px;
  border: 1px dashed rgba(20, 56, 112, 0.24);
  border-radius: 6px;
  pointer-events: none;
}

.cert-mini-head,
.cert-mini-title,
.cert-mini-no {
  margin: 0;
  position: relative;
  z-index: 1;
}

.cert-mini-head {
  font-size: 10px;
  color: #2f4766;
  font-weight: 600;
  line-height: 1.2;
}

.cert-mini-title {
  margin-top: 2px;
  font-size: 13px;
  color: #163d70;
  font-weight: 700;
  line-height: 1.25;
}

.cert-mini-no {
  margin-top: 4px;
  font-size: 10px;
  color: #36547a;
  font-weight: 600;
  line-height: 1.2;
}

/* =====================
   BOTTOM SECTION (Problems + CTA + Contact)
   ===================== */
.bottom-section {
  width: 100%;
  flex: 0 0 40%;
  background: linear-gradient(160deg, #daeaf8 0%, #e8f4ff 55%, #f0f8ff 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  overflow: visible;
}

/* Problems Label */
.problems-label {
  text-align: center;
  font-size: clamp(11px, 1.2vw, 14px);
  font-weight: 700;
  color: #1e5a9e;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: clamp(10px, 1.5vh, 18px);
  opacity: 0.9;
}

/* Problems Section */
.problems-section {
  margin-bottom: clamp(8px, 1.5vh, 20px);
}

/* Train wrapper: clip horizontally, allow vertical overflow for scale */
.problems-track-wrapper {
  overflow: hidden;
  max-width: 960px;
  width: 100%;
  margin: -24px auto;
  padding: 24px 0;
  cursor: default;
}

.problems-container {
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
  gap: 0;
  will-change: transform;
}

.problem-item {
  flex-shrink: 0;
  width: 192px;
  text-align: center;
  padding: clamp(10px, 1.5vh, 18px) clamp(6px, 1vw, 16px);
  position: relative;
  border-right: 1px solid rgba(30, 90, 158, 0.15);
}

.problem-item:last-child {
  border-right: none;
}

.icon-wrapper {
  width: clamp(44px, 5vw, 64px);
  height: clamp(44px, 5vw, 64px);
  margin: 0 auto clamp(8px, 1.2vh, 14px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  border: 1.5px solid rgba(30, 90, 158, 0.2);
  box-shadow: 0 2px 8px rgba(30, 90, 158, 0.1);
}

.problem-icon-img {
  width: 58%;
  height: 58%;
  object-fit: contain;
}

.problem-text {
  font-size: clamp(13px, 1.35vw, 17px);
  color: #1e3a5f;
  line-height: 1.6;
  font-weight: 800;
  margin: 0;
  font-family: "Hiragino Kaku Gothic ProN", "Yu Gothic", "Meiryo", sans-serif;
  text-shadow: none;
}

/* CTA Section */
.cta-section {
  margin-bottom: clamp(6px, 1.2vh, 18px);
}

.cta-button {
  background: linear-gradient(135deg, #f0c040 0%, #d9a012 100%);
  border: none;
  color: #1a2a10;
  font-size: clamp(13px, 1.3vw, 16px);
  font-weight: 800;
  padding: clamp(11px, 1.3vh, 16px) clamp(24px, 3vw, 40px);
  border-radius: 40px;
  box-shadow: 0 6px 24px rgba(240, 192, 64, 0.4);
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  letter-spacing: 0.5px;
}

.cta-button:hover {
  background: linear-gradient(135deg, #ffd050 0%, #e8b020 100%);
  transform: translateY(-2px);
  box-shadow: 0 10px 32px rgba(240, 192, 64, 0.55);
}

.cta-arrow {
  font-size: 13px;
  margin-left: 10px;
}

/* Contact Section */
.contact-section ,
.contact-section-mobile {
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(30, 90, 158, 0.18);
  padding: 10px 25px;
  border-radius: 10px;
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0 2px 12px rgba(30, 90, 158, 0.08);
}
.contact-section-mobile {
  display: none;
}
.contact-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
  flex-wrap: wrap;
}

.contact-phone {
  display: flex;
  align-items: center;
  gap: 8px;
}

.phone-icon {
  font-size: 18px;
  color: #1e7ab8;
}

.phone-number {
  font-size: 26px;
  font-weight: 700;
  color: #1e3a5f;
  letter-spacing: 0.5px;
  font-family: "Arial", sans-serif;
}

.business-hours {
  font-size: 10px;
  color: #4a6080;
  white-space: nowrap;
  margin-left: 5px;
}

.contact-btn-wrapper {
  flex-shrink: 0;
}

.consultation-button {
  background-color: #e05040;
  border: none;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 22px;
  border-radius: 20px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  animation: pulse 1.5s infinite;
  cursor: pointer;
}

.consultation-button:hover {
  background-color: #c84030;
  animation: none;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(224, 80, 64, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(224, 80, 64, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(224, 80, 64, 0);
  }
}

/* =====================
   RESPONSIVE
   ===================== */

/* Large Desktop (1200px+) */
@media (min-width: 1200px) {
  .main-title {
    font-size: 36px;
  }

  .main-title-brand {
    font-size: 48px;
  }

  .main-title-brand .highlight {
    font-size: 64px;
  }

  .sub-title {
    font-size: 18px;
  }
}

/* Extra Large (1400px+) */
@media (min-width: 1400px) {
  .top-content {
    padding: 0 60px;
  }

  .title-section {
    max-width: 660px;
  }

  .main-title {
    font-size: 42px;
  }

  .main-title-brand {
    font-size: 56px;
  }

  .main-title-brand .highlight {
    font-size: 74px;
  }

  .cert-mini-title {
    font-size: 15px;
  }

  .cert-mini-head,
  .cert-mini-no {
    font-size: 12px;
  }

  .cert-mini-card {
    padding: 10px 12px;
  }

  .phone-number {
    font-size: 30px;
  }

  .phone-icon {
    font-size: 22px;
  }

  .contact-section,
  .contact-section-mobile {
    max-width: 720px;
    padding: 12px 32px;
  }

  .problems-track-wrapper {
    max-width: 1200px;
  }

  .problem-item {
    width: 230px;
  }
}

/* Ultra Wide (1700px+) */
@media (min-width: 1700px) {
  .title-section {
    max-width: 780px;
  }

  .main-title {
    font-size: 45px;
  }

  .main-title-brand {
    font-size: 60px;
  }

  .main-title-brand .highlight {
    font-size: 80px;
  }

  .cert-mini-title {
    font-size: 17px;
  }

  .cert-mini-head,
  .cert-mini-no {
    font-size: 13px;
  }

  .phone-number {
    font-size: 36px;
  }

  .consultation-button {
    font-size: 15px;
    padding: 13px 28px;
  }

  .contact-section,
  .contact-section-mobile {
    max-width: 860px;
  }

  .problems-track-wrapper {
    max-width: 1400px;
  }

  .problem-item {
    width: 280px;
  }

  .cta-button {
    font-size: 18px;
    padding: 16px 48px;
  }
}

/* Tablet Landscape (992px - 1199px) */
@media (max-width: 1199px) {
  .top-section {
    flex: 0 0 62%;
  }

  .bottom-section {
    flex: 0 0 38%;
  }

  .top-content {
    padding: 0 30px;
  }

  .main-title {
    font-size: 28px;
  }

  .main-title-brand {
    font-size: 36px;
  }

  .main-title-brand .highlight {
    font-size: 48px;
  }

  .sub-title {
    font-size: 15px;
  }
}

/* Tablet Portrait (768px - 991px) */
@media (max-width: 991px) {
  #header2 {
    height: auto;
    min-height: 90vh;
    overflow: visible;
  }

  .top-section {
    flex: none;
    min-height: 52vh;
    padding: 35px 0;
  }

  .bottom-section {
    flex: none;
    padding: 22px 0;
    overflow: visible;
  }

  .top-section::before {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.9) 0%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0.2) 80%
    );
  }

  .title-section {
    max-width: 450px;
  }

  .main-title {
    font-size: 24px;
  }

  .main-title-brand {
    font-size: 32px;
  }

  .main-title-brand .highlight {
    font-size: 42px;
  }

  .sub-title {
    font-size: 14px;
  }

  .cert-mini-section {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
  }

  .cert-mini-card {
    padding: 6px 6px;
  }

  .cert-mini-title {
    font-size: 12px;
  }

  .cert-mini-no {
    font-size: 9px;
  }

  .problem-item {
    width: auto;
    flex: 1;
    padding: 8px 10px;
  }
}

/* Mobile Landscape (576px - 767px) */
@media (max-width: 767px) {
  #header2 {
    height: auto;
    overflow: visible;
  }

  .top-section {
    flex: none;
    min-height: 50vh;
    padding: 30px 0;
    background-position: left center;
  }

  .bottom-section {
    flex: none;
    overflow: visible;
  }

  .top-section::before {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(255, 255, 255, 0.7) 50%,
      rgba(255, 255, 255, 0.3) 75%
    );
  }

  .top-content {
    padding: 0 20px;
  }

  .title-section {
    max-width: 65%;
  }

  .main-title {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .main-title-brand {
    font-size: 26px;
    margin-bottom: 8px;
  }

  .main-title-brand .highlight {
    font-size: 34px;
  }

  .sub-title {
    font-size: 13px;
  }

  .cert-mini-section {
    grid-template-columns: 1fr;
    gap: 6px;
    max-width: 300px;
  }

  .cert-mini-card {
    text-align: left;
    padding: 7px 10px;
  }

  .problems-track-wrapper {
    overflow: visible;
    padding: 0;
    margin: 0;
  }

  .problems-container {
    width: 100%;
    flex-wrap: nowrap;
    justify-content: center;
  }

  .problem-item {
    width: auto;
    flex: 1;
    padding: 8px 5px;
  }

  .problem-text {
    font-size: 13px;
  }

  .cta-button {
    font-size: 13px;
    padding: 12px 24px;
  }

  .contact-inner {
    flex-direction: column;
    gap: 12px;
  }

  .phone-number {
    font-size: 22px;
  }
}

/* Mobile Portrait (< 576px) */
@media (max-width: 575px) {
  #header2 {
    height: auto;
    overflow: visible;
  }

  .top-section {
    flex: none;
    min-height: 48vh;
    padding: 25px 0;
    background-position: left center;
  }

  .bottom-section {
    flex: none;
    overflow: visible;
  }

  .top-section::before {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(255, 255, 255, 0.8) 45%,
      rgba(255, 255, 255, 0.4) 70%
    );
  }

  .top-content {
    padding: 0 15px;
  }

  .title-section {
    max-width: 70%;
    text-align: left;
  }

  .main-title {
    font-size: 18px;
    line-height: 1.4;
  }

  .main-title-brand {
    font-size: 22px;
  }

  .main-title-brand .highlight {
    font-size: 28px;
    letter-spacing: 1px;
  }

  .sub-title {
    font-size: 12px;
    margin-top: 8px;
  }

  .cert-mini-section {
    max-width: 100%;
  }

  .problems-track-wrapper {
    overflow: visible;
    padding: 0;
    margin: 0;
  }

  .problems-container {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0;
    width: 100%;
  }

  .problem-item {
    width: calc(33.33% - 2px);
    flex: none;
    border-right: 1px solid rgba(30, 90, 158, 0.15);
    border-bottom: 1px solid rgba(30, 90, 158, 0.15);
    padding: 12px 6px;
  }

  .problem-item:nth-child(3),
  .problem-item:nth-child(5) {
    border-right: none;
  }

  .problem-text {
    font-size: 13px;
    line-height: 1.5;
  }

  .cta-button {
    font-size: 12px;
    padding: 11px 20px;
    border-radius: 24px;
  }

  .contact-section-mobile {
    display: block;
    padding: 12px 15px;
    margin: 0 10px;
  }
  .contact-section{
    display: none;
  }

  .consultation-button {
    font-size: 12px;
    padding: 9px 18px;
  }

  .phone-number {
    font-size: 20px;
  }

  .business-hours {
    font-size: 9px;
  }
}

/* Extra small devices (< 400px) */
@media (max-width: 399px) {
  .top-section {
    min-height: 160px;
    padding: 25px 0;
  }

  .title-section {
    max-width: 75%;
  }

  .main-title {
    font-size: 16px;
  }

  .main-title-brand {
    font-size: 20px;
  }

  .main-title-brand .highlight {
    font-size: 24px;
  }

  .sub-title {
    font-size: 11px;
  }

  .problem-item {
    width: calc(50% - 10px);
  }

  .cta-button {
    font-size: 11px;
    padding: 10px 16px;
  }
}
</style>
